import React, { useEffect, useState } from "react";
import "../App.css";
import { useForm } from "react-hook-form";
import axios from ".././axios-interceptor";
import { base_url, INVESTOR_ROLE, CRYPTO_SECRET_KEY, COMPLIANCE_APPROVED } from "./../utilities";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import CryptoJS from 'crypto-js'
import { ResetPassword } from "../BusinessFlow/BusinessLogin";
import moment from "moment";
import { PassWordExpiryModal } from "../AdminFlow/AdminLoginPage";
import { decrypt, encrypt } from "../utils";
import Cookies from 'js-cookie';

const InvestorLogin = (props) => {

  console.log("investor login");
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth < 920) {
  //       alert("Access restricted to desktop devices only. Please use a desktop device to continue. 22");
  //     }
  //   };
  //   handleResize();
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  const handleLogin = () => { };

  const [showPWDExpModal, setShowPWDExpModal] = useState(false)


  const handlePWDExpiry = () => {
    setShowPWDExpModal(false)
    setModalShow(true)
  }

  const handleCloseExpModal = () => {
    setShowPWDExpModal(false)
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const CustomToast = ({ date }) => (
    <div>
      <div>
        Your KYC Expired on : {moment(date).format("DD-MMM-YYYY")}.
      </div>
      <div>
        {/* <p>Click  <a href="/kycform" className="text-primary">here</a> to fill the form.</p> */}
        {/* <p>Click  <a href="/investorsettings" className="text-primary">here</a> to fill the form.</p> */}
        <p>
          Click{" "}
          <a
            href="/investorsettings"
            className="text-primary"
            onClick={() => Cookies.set("kyc_currentPage", 1,)}
          >
            here
          </a>{" "}
          to fill the form.
        </p>

      </div>

    </div>
  );

  const onSubmit = (data) => {
    if (data !== null && data !== '') {
      let hashedpassword = CryptoJS.AES.encrypt(data.password, CRYPTO_SECRET_KEY).toString();
      let hashedemail = CryptoJS.AES.encrypt(data.email, CRYPTO_SECRET_KEY).toString();
      let hashedrole = CryptoJS.AES.encrypt(INVESTOR_ROLE.toString(), CRYPTO_SECRET_KEY).toString();
      axios
        .post(base_url + "loginUser", {
          email_id: hashedemail,
          password: hashedpassword,
          role: hashedrole
        })
        .then((res) => {
          if (decrypt(res.data.message) === "password expired") {
            setShowPWDExpModal(true)
            return;
          }


          Cookies.set("investor_type", res.data?.investor_type?.type, { expires: 7 })
          Cookies.set("Inv_login_user", res.data?.result.user_name, { expires: 7 })
          const { access_token, auth_refresh_token } = res.data
          let data = res.data.result
          let user_id = res.data.result.user_id
          let user_name = res.data.result.user_name
          let msg = decrypt(res.data.message)
          if (msg === 'Invalid') {
            toast.error('Invalid Email or Password', {
              toastId: 223
            })

          }
          else if (data.role_code !== INVESTOR_ROLE) {
            toast.error('Please enter a valid credentials', {
              toastId: 2
            })
          }
          else {
            setDisabled(true)
            //admin session removing
            Cookies.remove("User_Accesstoken_Admin");
            Cookies.remove("User_Refreshtoken_Admin");
            // investor session removing
            Cookies.remove("User_Accesstoken_Business");
            Cookies.remove("User_Refreshtoken_Business");
            //creating the business session below
            Cookies.set("investor_user_name", user_name, { expires: 7 });
            const encryptrole_code = encrypt(data.role_code);
            Cookies.set("role_code", encryptrole_code, { expires: 7 });
            Cookies.set("investor_user_id", user_id, { expires: 7 });
            Cookies.set('User_Accesstoken', access_token, { expires: 7 })
            Cookies.set('User_Refreshtoken_Investor', auth_refresh_token, { expires: 7 })
            Cookies.set('User_Accesstoken_Investor', access_token, { expires: 7 })
            userSession()
            axios
              .post(base_url + "investor-master/get_investor_master_user", {
                user_id: Cookies.get("investor_user_id"),
              })
              .then((res) => {

                const kyc = res.data.data?.kyc;

                if (!Array.isArray(kyc) || kyc.length === 0) {
                  // no kyc data
                  navigate('/investorsettings')
                  Cookies.set("kyc_status", 0, { expires: 7 })
                } else if (kyc?.[0]?.status !== COMPLIANCE_APPROVED) {
                  // not approved
                  navigate('/investorsettings')
                  Cookies.set("kyc_status", 0, { expires: 7 })
                }


                // if (res.data.data?.kyc?.length === 0 || res.data.data?.kyc[0]?.status != COMPLIANCE_APPROVED) {
                //   alert("res.data.data.kyc?.length", res.data.data.kyc?.length)

                //   navigate('/investorsettings')
                //   Cookies.set("kyc_status", 0, { expires: 7 })

                // } 
                else {
                  navigate('/investordashboard')
                  Cookies.set("kyc_status", 2, { expires: 7 })
                  setTimeout(() => {
                    if (res.data.data?.kyc[0]?.kyc_expiry_date < new Date().getTime()) {
                      toast(<CustomToast date={res.data.data?.kyc[0]?.kyc_expiry_date} />, {
                        autoClose: 5000,
                        customId: 'custom-toast',
                      });
                    }
                  }, 2000);
                }
              })
              .catch((error) => {
                console.error("API ERROR:", error);
                toast.error("Something went wrong. Please try again.");
              });
            // Cookies.set("kyc_status", 0)
            // navigate('/investordashboard');
          }
        });
    }
  };
  const userSession = () => {
    setInterval(() => {
      axios.post(base_url + "user/refreshtoken", {
        "auth_refresh_token": Cookies.get('User_Refreshtoken_Investor')
      })
        .then(res => {
          Cookies.set('User_Accesstoken_Investor', res.data?.access_token, { expires: 7 })
        })
        .catch(err => {
          console.log(err);
        })
    }, 50 * 60 * 1000);
  }

  // const handleClose = () => {
  //   setModalShow(false)
  //   if(modalShow= false){
  //     setEmail('')
  //   }
  // };


  return (
    <div className="my-4">

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group mb-3 ">
          <label htmlFor="email">Email<span className="">*</span></label>
          <input
            {...register("email", { required: true })}

            id="email"
            type="text"
            className="form-control rounded px-4 py-3 border-0"
            placeholder="Please enter your Email"
          />
          {errors.email && (
            <span style={{ color: "#fd5a5a" }}>Please enter an Email </span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="password">Password<span className="">*</span></label>
          <input
            {...register("password", { required: true })}
            id="password"
            type="password"
            className="form-control rounded px-4 py-3 border-0"
            placeholder="Please enter your password"
          />
          <div className="d-flex justify-content-between">
            {errors.password && (
              <span style={{ color: "#fd5a5a" }}>Enter a password </span>
            )}
            <span className="forgot_pwd" onClick={() => setModalShow(true)}>Reset Password?</span>
          </div>
        </div>

        <div className="d-grid">
          <button className="btn blue_btn mt-5 fw-bolder" disabled={disabled} onClick={handleLogin}>
            Login
          </button>
        </div>
      </form>




      <ResetPassword modalShow={modalShow} setModalShow={setModalShow} />
      <PassWordExpiryModal
        showPWDExpModal={showPWDExpModal}
        handleCloseExpModal={handleCloseExpModal}
        handlePWDExpiry={handlePWDExpiry}
      />

    </div>
  );
};

export default InvestorLogin;
